import { render, staticRenderFns } from "./ConnectedDetailsTab.vue?vue&type=template&id=f4bfeaf6&scoped=true&"
import script from "./ConnectedDetailsTab.vue?vue&type=script&lang=js&"
export * from "./ConnectedDetailsTab.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedDetailsTab.vue?vue&type=style&index=0&id=f4bfeaf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bfeaf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VCol,VContainer,VIcon,VImg,VOverlay,VProgressCircular,VRow,VSwitch,VTextField,VTooltip})
